import { useContext } from "react";
import { AuthContext } from "../authentication/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    navigate("/login");
  });

  return;
};

export default Logout;
